var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAspasDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 8C21.9999 12.4183 25.5817 16 29.9999 16C34.4182 16 37.9999 12.4183 37.9999 8C37.9999 3.58172 34.4182 0 29.9999 0C25.5817 0 21.9999 3.58172 21.9999 8Z",
    fill: "#F57F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9999 26.5C38.9999 20 38.6666 11.8333 37.9999 7.5L28.9999 15C29.1666 16.5 31.1324 19.0728 30.4999 23.5C29.9999 27 28.6666 28.3333 26.4999 31.5C27.1665 30.8333 29.4096 30.3894 32.9999 26.5Z",
    fill: "#F57F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.10352e-05 8C-6.10352e-05 12.4183 3.58166 16 7.99994 16C12.4182 16 15.9999 12.4183 15.9999 8C15.9999 3.58172 12.4182 0 7.99994 0C3.58166 0 -6.10352e-05 3.58172 -6.10352e-05 8Z",
    fill: "#F57F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 26.5C16.9999 20 16.6666 11.8333 15.9999 7.5L6.9999 15C7.16656 16.5 9.1324 19.0728 8.49994 23.5C7.99994 27 6.66655 28.3333 4.49988 31.5C5.16654 30.8333 7.40962 30.3894 10.9999 26.5Z",
    fill: "#F57F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspasDown);
export default __webpack_public_path__ + "static/media/aspasDown.c65f573649061a80b7931a994e6c2dcd.svg";
export { ForwardRef as ReactComponent };